import request from '@/util/http';

export default {
  roleList,      //获取所有后台角色列表
  addRole,       //添加后台角色
  delRole,       //删除后台角色
  roleAuthList,  //查看角色已有权限
  editRoleAuth,  //编辑角色权限
}

//接口文件呢，post请求参数名为data，get请求参数名为params
function roleList(data) {
  return request({
    url: 'sys/api/getrole',
    method: 'post',
    data
  })
}

function addRole(data) {
  return request({
    url: 'sys/api/addupdaterole',
    method: 'post',
    data
  })
}

function delRole(data) {
  return request({
    url: 'sys/api/deletesysrole',
    method: 'post',
    data
  })
}

function roleAuthList(data) {
  return request({
    url: 'sys/api/getuserpermission',
    method: 'post',
    data
  })
}

function editRoleAuth(data) {
  return request({
    url: 'sys/api/rolesetpermission',
    method: 'post',
    data
  })
}